import Vue from "vue";
import Router from "vue-router";



Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new Router({
  routes: [{
    path: "/login",
    component: (resolve) => require(["@/pages/login"], resolve),
    meta: {
      title: "登录",
      keepAlive: false,
    },
  },

  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/baseIndex",
    name: "",
    component: (resolve) => require(["@/pages/baseIndex"], resolve),
    meta: {
      title: "",
      keepAlive: false,
    },
    redirect: "/WaybillManage/ComprehensiveQuery",
    children: [

      {
        path: "/WaybillManage/ComprehensiveQuery",
        component: (resolve) => require(["@/pages/BusinessOrder/WaybillManage/ComprehensiveQuery"], resolve),
        meta: {
          title: "运单列表",
          keepAlive: true,
        },
      },
      {
        //数据看板
        path: "/controlPanel",
        component: (resolve) => require(["@/pages/controlPanel"], resolve),
        meta: {
          title: "控制面板",
          keepAlive: true,
        },
      },
      {
        path: "/WaybillManage/WaybillDetails",
        component: (resolve) =>
          require([
            "@/pages/BusinessOrder/WaybillManage/WaybillDetails",
          ], resolve),
        meta: {
          title: "运单详情",
          keepAlive: true,
        },
      },
      {
        path: "/WaybillManage/WaybillAttachment",
        component: (resolve) =>
          require([
            "@/pages/BusinessOrder/WaybillManage/WaybillAttachment",
          ], resolve),
        meta: {
          title: "运单附件",
          keepAlive: true,
        },
      },
      {
        path: "/WaybillManage/WaybillTracking",
        component: (resolve) =>
          require([
            "@/pages/BusinessOrder/WaybillManage/WaybillTracking",
          ], resolve),
        meta: {
          title: "运单跟踪",
          keepAlive: true,
        },
      },
      {
        path: "/WaybillManage/statementAccount",
        component: (resolve) =>
          require([
            "@/pages/BusinessOrder/WaybillManage/statementAccount",
          ], resolve),
        meta: {
          title: "对账单",
          keepAlive: true,
        },
      },
      {
        path: "/WaybillManage/statementAccountDetails",
        component: (resolve) =>
          require([
            "@/pages/BusinessOrder/WaybillManage/statementAccountDetails",
          ], resolve),
        meta: {
          title: "对账单详情",
          keepAlive: true,
        },
      },
      {
        path: "/message/messageList",
        component: (resolve) => require(["@/pages/message/messageList"], resolve),
        meta: {
          title: "消息通知",
          keepAlive: true,
        },
      },
      {
        path: "/message/exportList",
        component: (resolve) => require(["@/pages/message/exportList"], resolve),
        meta: {
          title: "导出记录",
          keepAlive: true,
        },
      },



    ],
  },
  ],
});



export default router;